export default "__VITE_ASSET__CZZUJKId__"